// extracted by mini-css-extract-plugin
module.exports = {"container":"SmartBanner_container__3Zp0y","close":"SmartBanner_close__1j2sZ"};